import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserContext } from '../context/userContext';
import StartupError from '../pages/auth/StartupError';

/** Auth0 returns here (`#/login/callback`); the session is already in place by then. */
export default function LoginCallback() {
    const navigate = useNavigate();
    const { isAuthenticated, isLoading, status, login } = useUserContext();

    useEffect(() => {
        if (!isLoading && isAuthenticated) navigate('/owner/dashboard', { replace: true });
    }, [isLoading, isAuthenticated, navigate]);

    if (status === 'error') return <StartupError onRetry={login} />;
    return null;
}
